module.exports = __webpack_public_path__ + "img/wx.ec067f2f.svg";